<template>
  <div v-if="$route.name == 'Candidates'">
    <div class="grid grid-cols-2 gap-6">
      <div>
        <TButtonSvg label="New" color="white" disabled="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" />
            <circle cx="12" cy="12" r="9" />
            <line x1="9" y1="12" x2="15" y2="12" />
            <line x1="12" y1="9" x2="12" y2="15" />
          </svg>
        </TButtonSvg>
        <p class="mt-2 text-sm leading-5 text-gray-500">
          Create a new candidate and validate their phone number all in the same form. Great for one off candidates.
        </p>
      </div>
      <div>
        <TButtonSvg label="Export" color="white" disabled="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" />
            <line x1="17" y1="7" x2="7" y2="17" />
            <polyline points="8 7 17 7 17 16" />
          </svg>
        </TButtonSvg>
        <p class="mt-2 text-sm leading-5 text-gray-500">
          Export all of your candidates into a CSV file inlcuding unsubscribes.
        </p>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="grid grid-cols-2 gap-3">
      <div>
        <TButtonSvg label="Chat" color="white" disabled="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1" />
            <line x1="12" y1="12" x2="12" y2="12.01" />
            <line x1="8" y1="12" x2="8" y2="12.01" />
            <line x1="16" y1="12" x2="16" y2="12.01" />
          </svg>
        </TButtonSvg>
        <p class="mt-2 text-sm leading-5 text-gray-500">
          Opens the chat window so you can begin sending and receiving messages from a candidate.
        </p>
      </div>
      <div>
        <TButtonSvg label="Edit" color="white" disabled="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4" />
            <line x1="13.5" y1="6.5" x2="17.5" y2="10.5" />
          </svg>
        </TButtonSvg>
        <p class="mt-2 text-sm leading-5 text-gray-500">
          Edit a candidate with pre-populated information from the specific candidate you are on.
        </p>
      </div>
      <div>
        <TButtonSvg label="Delete" color="white" disabled="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <line x1="4" y1="7" x2="20" y2="7" />
            <line x1="10" y1="11" x2="10" y2="17" />
            <line x1="14" y1="11" x2="14" y2="17" />
            <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
            <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
          </svg>
        </TButtonSvg>
        <p class="mt-2 text-sm leading-5 text-gray-500">
          Permanently deletes a candidate and any message history. Use with caution. This data cannot be recovered.
        </p>
      </div>
    </div>
  </div>
</template>
